import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import { brand, fonts, CALENDLY_URL } from '../theme/brand';

const sections = [
  { title: 'What I build', hash: '#build' },
  { title: 'Mobile apps', hash: '#mobile' },
  { title: 'Past work', hash: '#work' },
  { title: 'About', hash: '#about' },
];

const linkSx = {
  textDecoration: 'none',
  color: '#C3C7CF',
  fontSize: 15,
  '&:hover': { color: brand.textStrong },
  '&:focus-visible': { outline: `2px solid ${brand.accent}`, outlineOffset: '4px', borderRadius: '2px' },
};

const ctaSx = {
  textDecoration: 'none',
  bgcolor: brand.accent,
  color: brand.ink,
  fontWeight: 600,
  fontSize: 15,
  px: 2.25,
  borderRadius: '6px',
  minHeight: 44,
  boxSizing: 'border-box',
  display: 'inline-flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  '&:hover': { filter: 'brightness(1.08)' },
  '&:focus-visible': { outline: `3px solid ${brand.textStrong}`, outlineOffset: '2px' },
};

const Header = () => {
  const [anchorElNav, setAnchorElNav] = useState(null);

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{ bgcolor: brand.ink, color: brand.text, borderBottom: '1px solid #262A33', zIndex: 1100, fontFamily: fonts.body }}
    >
      <Toolbar disableGutters sx={{ maxWidth: 1240, width: '100%', mx: 'auto', px: 3, minHeight: '64px !important', gap: 2, justifyContent: 'space-between' }}>
        <Box component={Link} to="/" sx={{ display: 'flex', alignItems: 'center', gap: 1.25, textDecoration: 'none', color: brand.text }}>
          <Box component="span" aria-hidden="true" sx={{ width: 34, height: 34, bgcolor: brand.accent, color: brand.ink, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: fonts.display, fontWeight: 900, fontSize: 15, borderRadius: '6px' }}>
            AI
          </Box>
          <Box component="span" sx={{ fontFamily: fonts.display, fontWeight: 800, fontSize: 20, letterSpacing: '-0.01em' }}>
            AI This Job
          </Box>
        </Box>

        {/* Desktop navigation */}
        <Box component="nav" aria-label="Main" sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 3.5 }}>
          {sections.map((s) => (
            <Box key={s.hash} component={Link} to={{ pathname: '/', hash: s.hash }} sx={linkSx}>
              {s.title}
            </Box>
          ))}
          <Box component="a" href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" sx={ctaSx}>
            Book a free call
          </Box>
        </Box>

        {/* Mobile navigation */}
        <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', gap: 1 }}>
          <Box component="a" href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" sx={{ ...ctaSx, fontSize: 14, px: 1.75 }}>
            Free call
          </Box>
          <IconButton
            aria-label="Open menu"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={(e) => setAnchorElNav(e.currentTarget)}
            sx={{ color: brand.text, width: 44, height: 44 }}
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={Boolean(anchorElNav)}
            onClose={() => setAnchorElNav(null)}
            PaperProps={{ sx: { bgcolor: brand.panel, color: brand.text, border: `1px solid ${brand.line}`, minWidth: 200 } }}
          >
            {sections.map((s) => (
              <MenuItem
                key={s.hash}
                component={Link}
                to={{ pathname: '/', hash: s.hash }}
                onClick={() => setAnchorElNav(null)}
                sx={{ fontFamily: fonts.body, minHeight: 44, '&:hover': { bgcolor: '#262A33' } }}
              >
                {s.title}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
